import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="developer-text">
        🚀 Developed with ❤️ by <strong>Amit Kalsariya</strong>
      </p>
    </footer>
  );
};

export default Footer;
